import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1536a18d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "left-page" }
const _hoisted_2 = { class: "container-top" }
const _hoisted_3 = { class: "weather" }
const _hoisted_4 = {
  class: "iconfont icon-svg",
  "aria-hidden": "true"
}
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = { class: "temp-des" }
const _hoisted_7 = { class: "temp" }
const _hoisted_8 = { class: "txt-temp" }
const _hoisted_9 = { class: "txt-value" }
const _hoisted_10 = { class: "container-bottom" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "item-top" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-bottom" }, "湿度", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "item-top" }
const _hoisted_16 = { class: "item-bottom" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "item-top" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-bottom" }, "气压", -1))

import qs from 'qs';
import { useStore, } from 'vuex';
import {
  computed, onMounted, watch, ref,
} from 'vue';
import { weatherRender, windDirection, } from '@/utils/index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const regionId = computed(() => store.state.OLMap.regionId) || 320100000000;
// const currentWeather = computed(() => store.state.airStatus.currentWeather);
const frameData = computed(() => store.state.gateway.frameData);
const getCurrentWeather = () => {
  const params = qs.stringify({
    regionId: regionId.value,
  });

  store.dispatch('airStatus/getCurrentWeather', params);
};

watch(regionId, (cur) => {
  if (cur) {
    getCurrentWeather();
  }
});

onMounted(() => {
  if (regionId.value) {
    getCurrentWeather();
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['left-container', _unref(weatherRender)(_unref(frameData).weather)])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", _hoisted_4, [
            _createElementVNode("use", {
              "xlink:href": `#icon-${_unref(weatherRender)(_unref(frameData).weather)}`
            }, null, 8, _hoisted_5)
          ])),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(frameData).weatherVo?.tem !== '-9999' && _unref(frameData).weatherVo?.tem  ? Number(_unref(frameData).weatherVo?.tem).toFixed(0) : '-') + "℃", 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(frameData)?.weatherAm !== _unref(frameData).weatherPm ? `${_unref(frameData)?.weatherAm || '-'}转${_unref(frameData)?.weatherPm || '-'}`: (_unref(frameData)?.weatherAm || '-')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(frameData).weatherVo?.rhu !== '-9999' && _unref(frameData).weatherVo?.rhu ? Number(_unref(frameData).weatherVo?.rhu).toFixed(1): '-') + "%", 1),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(frameData).weatherVo?.windS !== '-9999' && _unref(frameData).weatherVo?.windS ? Number(_unref(frameData).weatherVo?.windS).toFixed(1) : '-') + "m/s", 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(frameData).weatherVo?.windD !== '-9999' && _unref(frameData).weatherVo?.windD ? _unref(windDirection)(Number(_unref(frameData).weatherVo?.windD)) : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(frameData).weatherVo?.prs !== '-9999' && _unref(frameData).weatherVo?.prs ? Number(_unref(frameData).weatherVo?.prs).toFixed(1) : '-') + "hPa", 1),
          _hoisted_19
        ])
      ])
    ], 2)
  ]))
}
}

})